<template>
  <div class="activeList ">
    <Search @typesChange="typesChange" placeholder="活动名称/地点/门店"></Search>
    <!-- 滑动区域 -->
    <div class="scroll">
      <van-list  v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList" :immediate-check="false">
        <template v-for="item in list" >
          <Card :item="item"></Card>
        </template>
      </van-list>
    </div>
    <!-- 分页数据计算 -->
    <div class="loaded">已加载 {{list.length}}/{{total}}</div>

    <!-- 定位 -->
    <div :class="hasAddAuth ? 'orientation-bottom' : 'orientation-bottom-1'">
      <!-- 主页 -->
      <div class="homePage" @click="$router.push('/')">
        <img :src="require('@/assets/img/homePage.png')" class="homePageImg" alt="">
      </div>
      <!-- 添加 -->
      <div class="add" @click="toApply" v-if="hasAddAuth">
        <img :src="require('@/assets/img/add.png')" class="addImg" alt="">
      </div>
    </div>
    <!--<div class="add-active" @click="toApply">-->
      <!--<img :src="require('@/assets/img/add_circle.png')" >-->
    <!--</div>-->
  </div>
</template>
<script>
  import Search from './component/activeSearch.vue'
  import Card from './component/reportCard.vue'
  import apiActive from '@/api/active'

  export default{
    data(){
      return {
        loading:false,
        finished:false,
        total:0,
        list:[],
        userId:'',
        campType:'',
        campName:'',
        pageNo:1,
        pageSize:10,
        id:'',
        hasAddAuth : true,//是否有新增权限
      }
    },
    components:{
      Search,
      Card
    },
    watch:{
      '$route' (to, from) {
        if(from.name == 'Index'){
          this.campType = ''
          this.campName = ''
          this.list = []
          this.pageNo = 1
          this.loading = false
          this.finished = false
          this.getList();
        }
      }
    },
    methods:{
      toApply(){
        this.$router.push('/active/reportApply')
      },
      typesChange(data){
        this.campType = data.campType
        this.campName = data.campName
        this.list = []
        this.pageNo = 1
        this.getList()
      },
      getList(){
        apiActive.reportPage({
          salesId:this.userId,
          campType:this.campType,
          k:this.campName,
          pageNo:this.pageNo,
          pageSize:this.pageSize
        }).then(response=>{
          if(response.success){
            var pageList = response.data.list;
            this.list.push(...pageList);

            this.total = response.data.totalRow
            this.lastPage = response.data.lastPage;
            if(!this.lastPage){
              this.pageNo=this.pageNo+1
            }
          }else{
            this.$title(`获取活动列表失败,${response.msg}`);
          }

          if(this.lastPage){
            this.finished = true;
          }
          this.loading = false;
        })
      },

    },
    mounted(){
      this.hasAddAuth = this.$wxuserUtil.hasFunAuthByRoute(this.$route.path,this.$wxuserUtil.funcKey.Created);
    },
    created(){
      this.userId = this.$wxuserUtil.getUserId();
          this.getList()
    },
  }
</script>
<style scoped lang="less" rel="stylesheet/less">
  @import "../../style/pageStyle/pageView-activeList.less";
  .add-active{
    position: fixed;
    right:10px;
    bottom:100px;
    z-index:2;
  img{
    width:50px;
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/active/reportList.vue